/**
 * PlanLimitNote — the inline "Plan limit — upgrade" note (phase 10 §C,
 * explicitly NOT a modal). Dashboard create flows (AgentSheet save,
 * ScheduleEditor save, run-now with goal/loop) catch api.ts's
 * PlanLimitError (status 402) and render this where their error hint
 * would go; the link lands on /pricing. Styles: .dsh-plan-note in
 * dashboard.css.
 */
import { Link } from "react-router-dom";
import type { PlanLimitError } from "../lib/api";
import { Icon, I } from "../kit";

/** Human phrasing per gate — mirrors the plane's 402 body
 *  `{error:"plan_limit", limit, max?, plan?}`. */
function describe(err: PlanLimitError): string {
  const plan = err.plan ?? "current";
  switch (err.limit) {
    case "machines":
    case "agents":
    case "schedules": {
      const noun =
        err.max === 1 ? err.limit.slice(0, -1) : err.limit; // "1 machine"
      return err.max !== undefined
        ? `the ${plan} plan includes ${err.max} ${noun}`
        : `the ${plan} plan's ${err.limit} limit is reached`;
    }
    case "modes":
      return "goal & loop modes are a Pro feature";
    case "teams":
      return "creating teams needs the Teams plan";
    default:
      return `your ${plan} plan doesn't include this`;
  }
}

export function PlanLimitNote({ err }: { err: PlanLimitError }) {
  return (
    <div className="dsh-plan-note" role="status">
      <span className="ic">
        <Icon d={I.zap} size={14} />
      </span>
      <span>
        <strong>Plan limit</strong> — {describe(err)}.{" "}
        <Link to="/pricing">Upgrade →</Link>
      </span>
    </div>
  );
}
